import { useRef, useState, useEffect } from "react";
import { UseFormProps, useForm } from "../../hooks/useForm";
import { Catalogos } from "../../services/Catalogos";
import { IFRFService } from "../../services/IFRFService";
import { Helper } from "../../helper/Helper";
import { Modal } from "../modal/ModalPage";

import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import Footer from "react-multi-date-picker/plugins/range_picker_footer";
//import Gregorian_Bim from "react-date-object/locales/gregorian_es";
import Gregorian_es from "react-date-object/locales/gregorian_es";
import transition from "react-element-popper/animations/transition"

export class TabIFRFForm implements UseFormProps {
    rutaTematica:string='';
    rutaTematicaBimestre:string='';

    ID_TMNO_EMPA:string='';
    ID_DVSN_ECNA:string='';
    CV_ENTD_FDRA:string='';

    edad:string='';
    nivelIngreso:string='';

    fechaRango:string='';
    fechaRangoDate:Date[]=[];
    fechaInicio:Date = Catalogos.FIRST_DATE;
    fechaFin:Date = Catalogos.FIRST_DATE;

    yearIni:string='';
    bimIni:string='';
    yearFin:string='';
    bimFin:string='';

    R5_01:string = '' ;
    R5_03:string = '' ;
    R5_04:string = '' ;
    R5_04_02_01:string = '' ;
    R5_04_02_02:string = '' ;
    R5_04_02_03:string = '' ;
}

export const TabIFRF = () => {

    const { elementos, reset, updateAttDate, updateAttVal, handleClickEvent, handleChangeEvent }= useForm<TabIFRFForm>(new TabIFRFForm() );
    const { rutaTematica } = elementos;

    const ahref = useRef<HTMLAnchorElement>(null);
    const refBtnGenDesc = useRef<HTMLButtonElement>(null);
    const divCollapse = useRef<HTMLDivElement>(null);

    const selBimIni = useRef<HTMLSelectElement>(null);
    const selBimFin = useRef<HTMLSelectElement>(null);

    const [ numMetrs, setNumMetrs ] = useState<number>(0) ;

    const [ descargando, setDescargando ] = useState<boolean>(false) ;
    const [ fileReady, setFileReady ] = useState<boolean>(false) ;
    const [ error, setError ] = useState<string>('');
    const [ toggle, setToggle ] = useState(false);
    const [ datePicker, setDatePicker ] = useState<any>(null);

    const reset2 = () => {
        reset();

        setNumMetrs(0);

        if (divCollapse.current && divCollapse.current.className) {
            divCollapse.current.className = 'collapse hide';
        }

        const radiosVars = document.querySelectorAll<HTMLInputElement>( '.queryVars' );
        radiosVars.forEach(value => {
            value.disabled = false ;
        });
        const radiosMet = document.querySelectorAll<HTMLInputElement>( '.queryMetricas' );
        radiosMet.forEach(value => {
            value.disabled = false ;
        });

        if ( refBtnGenDesc && refBtnGenDesc.current ) {
            refBtnGenDesc.current.disabled = false ;
        }

        setDescargando(false) ;
        setFileReady(false) ;
        setError('')
    }

    const handleDates = (dP:any) => {
        console.log(dP)

        setDatePicker(dP);
        if( dP.length === 1 ) {
            updateAttDate( 'fechaInicio', new Date( dP[0].year, dP[0].month-1, 1 ) )
            //updateAttVal( 'fechaRango', Helper.getBimestre( new Date( dP[0].year, dP[0].month-1, 1 ) ) )
        } else if( dP.length === 2 ) {
            //updateAttDate( 'fechaInicio', Catalogos.FIRST_DATE )
            updateAttDate( 'fechaFin', new Date( dP[1].year, dP[1].month-1, 1 ) )
        } else {
            updateAttDate( 'fechaFin', Catalogos.FIRST_DATE )
        }
    }

    const updateDates = () => {
        if(datePicker) {
            if( datePicker.length === 1 ) {
                //updateAttDate( 'fechaFin', Catalogos.FIRST_DATE )
                updateAttVal( 'fechaRango', Helper.getBimestre( new Date( datePicker[0].year, datePicker[0].month-1, 1 ) ) + ' al...' )
            } else if( datePicker.length === 2 ) {
                //updateAttDate( 'fechaFin', new Date( datePicker[1].year, datePicker[1].month-1, 2 ) )
                updateAttVal( 'fechaRango', Helper.getBimestre( new Date( datePicker[0].year, datePicker[0].month-1, 1 ) ) + ' al ' + Helper.getBimestre( new Date( datePicker[1].year, datePicker[1].month-1, 1 ) ) )
            } else {
                updateAttVal( 'fechaRango' , '' )
            }
        } else {
            updateAttVal( 'fechaRango' , '' )
        }
    }

    const yearIni = () => {
        if( selBimIni && selBimIni.current ) {
            if ( selBimIni.current.selectedIndex === 0 ) {
                updateAttVal( 'bimIni', '' )
            }
        }
    }

    const yearFin = () => {
        if( selBimFin && selBimFin.current ) {
            if ( selBimFin.current.selectedIndex === 0 ) {
                updateAttVal( 'bimFin', '' )
            }
        }
    }

    const handleRadioClick = (clickEvent:React.MouseEvent<HTMLInputElement>) => {
        handleClickEvent( clickEvent );
        const target = clickEvent.currentTarget ;

        if(target.type === 'radio' ) {
            if (divCollapse.current && divCollapse.current.className ) {
                divCollapse.current.className = 'collapse ' ;
            }
        } else {
            if ( target.name.startsWith( 'R5_' ) ) {
                const radios = document.querySelectorAll<HTMLInputElement>( '.queryMetricas' );
                if( target.checked === true ) {
                    setNumMetrs( numMetrs + 1 ) ;
                    radios.forEach(value => {
                        if( numMetrs >= 1 ) {
                            if( value.checked === false ) {
                                value.disabled = true ;
                            }
                        }
                    });
                } else {
                    setNumMetrs( numMetrs - 1 ) ;
                    radios.forEach(value => {
                        value.disabled = false ;
                    });
                }
            }
        }
    }

    const handleSubmit = async () => {
        console.log( elementos );

        const ifrfService = new IFRFService();

        setDescargando(true) ;
        setFileReady(false) ;
        setError('')
        setToggle(false)
        if ( refBtnGenDesc && refBtnGenDesc.current ) {
            refBtnGenDesc.current.disabled = true ;
        }

        await ifrfService.consultaIfrf( elementos )
            .then( data =>{
                if( data ) {
                    setFileReady(true) ;
                    setDescargando(false) ;
                    if( ahref && ahref.current ) {
                        ahref.current.className = '' ;
                        ahref.current.download = Helper.getFileNameExt( 'Masivos_IFRF', 'txt') ;
                        ahref.current.target = '_blank' ;
                        ahref.current.href = URL.createObjectURL( new Blob( [ data ], { type: 'text/plain' } ) ) ;
                        ahref.current.click();
                    }
                } else {
                    console.error("No se genero data/blob.")
                    setDescargando(false) ;
                    setError('Ocurrio algún error al generar el archivo.');
                }
            }).catch(e => {
                setDescargando(false) ;
                setError(e.message);
                if ( refBtnGenDesc && refBtnGenDesc.current ) {
                    refBtnGenDesc.current.disabled = false ;
                }
            });
    }

    useEffect(() => {
        /* cuerpo cuando se monta */
        if(error !=='') {
            setToggle(true)
        } else {
            setToggle(false)
        }
        return () => {
            /* cuerpo cuando se desmonta */
        }
    }, [error]);

    return (
        <div className="row" id="accordion">
            <form className="col-12">
            <div className="col-12 mt-4">
                <div className="row">
                    <div className="offset-7 offset-md-8 offset-xl-9 mt-4">
                        <button type="reset" className="btn btn-rojo button-rojo btn-block mt-3 mt-md-0" onClick={ reset2 }>Limpiar consulta</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 mt-4">
                        <p className="bold negro">Selecciona la ruta tematica</p>
                        <div className="custom-control custom-radio">
                            <input type="radio"
                                name="rutaTematica"
                                id='cubRecFis'
                                value='CIFRF_RFG'
                                className="custom-control-input"
                                data-toggle="collapse"
                                data-target="#collapse-ECUVE"
                                role="button"
                                onClick={ handleRadioClick }
                                />
                            <label className="custom-control-label" htmlFor='cubRecFis' >Recaudación fiscal</label>
                        </div>
                        <div className="custom-control custom-radio">
                            <input type="radio" 
                                name="rutaTematica"
                                id='cubRecFisEda'
                                value='CIFRF_RFE'
                                className="custom-control-input"
                                data-toggle="collapse"
                                data-target="#collapse-ECUVE"
                                role="button"
                                onClick={ handleRadioClick }
                                />
                            <label className="custom-control-label" htmlFor='cubRecFisEda' >Recaudación fiscal por edad</label>
                        </div>
                        <div className="custom-control custom-radio">
                            <input type="radio" 
                                name="rutaTematica"
                                id='cubRecFisNivIng'
                                value='CIFRF_RFNI'
                                className="custom-control-input"
                                data-toggle="collapse"
                                data-target="#collapse-ECUVE"
                                role="button"
                                onClick={ handleRadioClick }
                                />
                            <label className="custom-control-label" htmlFor='cubRecFisNivIng' >Recaudación fiscal por nivel de ingreso</label>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 mt-1">
                <hr></hr>
                <div className="row">
                    <div className="col-12 mt-1">
                        
                        <div id="collapse-ECUVE" className="collapse" aria-labelledby="ecuve" data-parent="#accordion" ref={ divCollapse } >
                            <div className="card-body">
                                <div className="card border-0">
                                    <div className="card-header fondo-blanco border-0" >
                                        <div className="row">
                                            <div className="col-12 mt-1">
                                                <div className="row">
                                                    <div className="col-12 col-md-4">
                                                        <div className="row form-group mt-4">
                                                            <div className="col-12"><p className="info-cubos bold negro">Selecciona las variables.</p></div>
                                                            <div className="col-12">
                                                                <div className="row">
                                                                    <div className="col-12"><p className="bold negro">Variables generales</p></div>
                                                                    
                                                                    { rutaTematica === 'CIFRF_RFG' &&
                                                                        Catalogos.CAT_VARIABLES_IFRF.json.map( (item,i) =>{ return (
                                                                            <div key={ item.Id + i } className= 'custom-control custom-checkbox col-12' >
                                                                                <input type="checkbox" name={ item.Id } id={ item.Id } value={ item.Id } className="custom-control-input queryVars" onClick={ handleRadioClick } />
                                                                                <label className="custom-control-label" htmlFor={ item.Id } >{ item.Tx }</label>
                                                                            </div> ) })
                                                                    }
                                                                    { rutaTematica === 'CIFRF_RFE' &&
                                                                        <div className= 'custom-control custom-checkbox col-12' >
                                                                            <input type="checkbox" name="edad" id="edad" value="ID_GRPO_EDAD" className="custom-control-input queryVars" onClick={ handleRadioClick } />
                                                                            <label className="custom-control-label" htmlFor="edad" >Edad</label>
                                                                        </div>
                                                                    }
                                                                    { rutaTematica === 'CIFRF_RFNI' &&
                                                                        <div className= 'custom-control custom-checkbox col-12' >
                                                                        <input type="checkbox" name="nivelIngreso" id="nivelIngreso" value="ID_NVEL_INGO" className="custom-control-input queryVars" onClick={ handleRadioClick } />
                                                                        <label className="custom-control-label" htmlFor="nivelIngreso" >Nivel de ingreso</label>
                                                                    </div>
                                                                    }
                                                                    <div className="custom-control custom-checkbox col-3">
                                                                        <input type="checkbox" name="rutaTematicaBimestre" value="ID_PRDO" className="custom-control-input" id='rutaTematicaBimestre' onClick={ handleClickEvent } />
                                                                        <label className="custom-control-label" htmlFor='rutaTematicaBimestre' >Bimestre</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-8">
                                                        <div className="row form-group mt-4">
                                                            <div className="col-12"><p className="info-cubos bold negro invisible">&nbsp;</p></div>
                                                            <div className="col-12">
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <p className="bold negro">Periodo</p>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-12 mt-1 text-center">
                                                                        {/*}
                                                                        <DatePicker
                                                                                onlyMonthPicker
                                                                                range
                                                                                locale={Gregorian_es}
                                                                                plugins={[
                                                                                    <DatePanel header="Selección"
                                                                                        placeholder="Fechas seleccionadas"
                                                                                        className=""
                                                                                        />
                                                                                    ]}
                                                                                dateSeparator=" a "
                                                                                minDate={ Catalogos.MIN_DATE }
                                                                                maxDate={ new Date() }
                                                                                
                                                                                format="MMMM YYYY"
                                                                                title="Seleccione el periodo"
                                                                                required
                                                                                inputClass="form-control select-mx "
                                                                                editable={false}
                                                                                placeholder="Seleccione un periodo"
                                                                                hideOnScroll
                                                                                onChange={ handleDates }
                                                                                id="fechaRango"
                                                                                name="fechaRango"
                                                                                value={ elementos.fechaRangoDate }
                                                                                style={{'width':300, 'cursor':'pointer'}}
                                                                                onClose={ updateDates }
                                                                                buttons={true}
                                                                            />
                                                                        <br />
                                                                        <p className="bold negro">
                                                                            <label className="rojo" style={{'width':300, 'cursor':'pointer'}} >{ elementos.fechaRango }</label>
                                                                        </p>
                                                                        */}
                                                                        <div className="row">
                                                                            <div className="col-12 mt-1">
                                                                                <div className="row">
                                                                                    <div className="col-12 col-md-6 mt-1">
                                                                                        <div className="row">
                                                                                            <div className="col-12 col-md-4 mt-1">
                                                                                                Bimestre inicial
                                                                                            </div>
                                                                                            <div className="col-12 col-md-4 mt-1">
                                                                                                <select className="form-control select-mx" name="yearIni" id="yearIni" onChange={ handleChangeEvent } onBlur={ yearIni }>
                                                                                                    <option value=''>Año</option>
                                                                                                    {
                                                                                                        Catalogos.YEARSBIM && Catalogos.YEARSBIM.map( (item, i) => <option key={i} value={ item }>{ item }</option> )
                                                                                                    }
                                                                                                </select>
                                                                                            </div>
                                                                                            <div className="col-12 col-md-4 mt-1">
                                                                                                <select className="form-control select-mx" name="bimIni" id="bimIni" onChange={ handleChangeEvent } ref={ selBimIni } >
                                                                                                    <option value=''>Bimestre</option>
                                                                                                    {
                                                                                                        Catalogos.CAT_BIMESTRES && Catalogos.CAT_BIMESTRES.json.map( (item, i) => { return ( elementos.yearIni === item.Anio+'' ? <option key={i} value={ item.Bmse }>{ item.Bmse }</option> : '' ) })
                                                                                                    }
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6 mt-1">
                                                                                        <div className="row">
                                                                                            <div className="col-12 col-md-4 mt-1">
                                                                                                Bimestre final
                                                                                            </div>
                                                                                            <div className="col-12 col-md-4 mt-1">
                                                                                                <select className="form-control select-mx" name="yearFin" id="yearFin" onChange={ handleChangeEvent } onBlur={ yearFin }>
                                                                                                    <option value=''>Año</option>
                                                                                                    {
                                                                                                        Catalogos.YEARSBIM && Catalogos.YEARSBIM.map( (item, i) => <option key={i} value={ item }>{ item }</option> )
                                                                                                    }
                                                                                                </select>
                                                                                            </div>
                                                                                            <div className="col-12 col-md-4 mt-1">
                                                                                                <select className="form-control select-mx" name="bimFin" id="bimFin" onChange={ handleChangeEvent } ref={ selBimFin }>
                                                                                                    <option value=''>Bimestre</option>
                                                                                                    {
                                                                                                        Catalogos.CAT_BIMESTRES && Catalogos.CAT_BIMESTRES.json.map( (item, i) => { return ( elementos.yearFin === item.Anio+'' ? <option key={i} value={ item.Bmse }>{ item.Bmse }</option> : '' ) })
                                                                                                    }
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div className="row form-group" >
                                                    <div className="row">
                                                        <div className="col-12 mt-4">
                                                            <hr></hr>
                                                            <p className="bold negro">Selecciona las metricas</p>
                                                            <div className="row">
                                                                {    
                                                                    rutaTematica === 'CIFRF_RFG' && Catalogos.CAT_METRICAS_IFRF.json.map( (item, i) =>{ return (
                                                                        
                                                                            <div key={ item.Id + i } className="custom-control custom-checkbox col-12">
                                                                                <input type="checkbox" name={ item.Id } id={ item.Id }
                                                                                    value={ item.Id }
                                                                                    className="custom-control-input queryMetricas"
                                                                                    onClick={ handleRadioClick } />
                                                                                <label className="custom-control-label" htmlFor={ item.Id } >{ item.Tx }</label>
                                                                            </div>
                                                                        ) })
                                                                }
                                                                {
                                                                    rutaTematica !== 'CIFRF_RFG' &&
                                                                    <div key='R5_03_X' className="custom-control custom-checkbox col-12">
                                                                        <input type="checkbox" name='R5_03' id='R5_03'
                                                                            value='R5_03'
                                                                            className="custom-control-input queryMetricas"
                                                                            onClick={ handleRadioClick } />
                                                                        <label className="custom-control-label" htmlFor='R5_03' >Número de relaciones laborales</label>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 mt-1">
                <div className="row align-items-end">
                    <div className="col-12 col-md-4">
                        
                    </div>
                    <div className="col-12 mt-4 text-center">
                        {
                            descargando &&
                                <span>
                                    <img alt="Generando reporte." src={ process.env.REACT_APP_CONTEXT_PATH + '/images/icono-descargando-animado.gif'} className="imgGif" />
                                    <br></br>
                                    <span style={{fontSize:'36px'}} >
                                        Ejecutando <span className="text-danger">Descarga</span>
                                    </span>
                                </span>
                        }
                        <span>
                            <br></br>
                            <a ref={ ahref } href="#" className={ fileReady ? '' : 'oculta' } >
                                <span>
                                    <img alt="Descargar" src={ process.env.REACT_APP_CONTEXT_PATH + '/images/icono-descarga-finalizada.png'} className="imgGif" />
                                    <br></br>
                                    <span style={{fontSize:'36px'}} >
                                        Decarga <span className="text-danger">Finalizada</span>
                                    </span>
                                </span>
                            </a>
                        </span>
                    </div>
                    <div className="col-12 col-md-4">
                        
                    </div>
                </div>
            </div>
            <div className="col-12 mt-1">
                <div className="row">
                    <div className="col-4 text-right">
                        
                    </div>
                    <div className="col-4 text-center">
                        <button ref={ refBtnGenDesc } type="button" className={ 'btn  btn-rojo button-rojo mt-3 mt-md-0 ' + ( refBtnGenDesc.current?.disabled ? 'invisible' : '' ) } onClick={ handleSubmit }>Generar descarga</button>
                    </div>
                    <div className="col-4 text-left">
                        
                    </div>
                </div>
            </div>
            <div className="col-12 align-items-end mt-4">
                <div className="row">
                    <div className="ccol-12 col-md-4 text-center">
                        <button type="button" className={ 'btn button-rojo btn-rojo  mt-3 mt-md-0   ' + ( refBtnGenDesc.current?.disabled ? '' : 'invisible' ) }
                            onClick={ e => { window.location.href = '/wps/portal/infonavitmx/mx2/derechohabientes/el_instituto/sii' } }
                            >Regresar</button>
                    </div>
                    <div className="col-12 col-md-4 text-center">
                        <span className={ fileReady ? 'btn button-rojo btn-rojo  mt-3 mt-md-0  ' : 'oculta' } onClick={ e => { e.preventDefault(); ahref.current?.click()} }>Exportar descarga
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                            <img alt="Generando reporte." src={ process.env.REACT_APP_CONTEXT_PATH + '/images/icono-descarga-finalizada.png'} className="imgBtn" />
                        </span>
                    </div>
                    <div className="col-12 col-md-4 text-center">
                        <button type="button" className={ 'btn button-rojo btn-rojo  mt-3 mt-md-0   ' + ( refBtnGenDesc.current?.disabled ? '' : 'invisible' ) }
                            onClick={ () => {
                                setDescargando(false);
                                setFileReady(false);
                                if ( refBtnGenDesc && refBtnGenDesc.current ) refBtnGenDesc.current.disabled = false ;
                            }}
                            >Nueva consulta</button>
                    </div>
                </div>
            </div>
            </form>
            {
                error !== '' && <Modal toggle={toggle} mensaje={ error} />
            }
        </div>
    );
}